export default {
  data() {
    return {
      hasPromo: false,
    };
  },

  props: {
    originalPrice: { String, Number },
    specialPrice: { String, Number },
    available: { Boolean },
    format: { type: String, default: "Large" },
  },

  mounted() {
    this.setPromoStatus();
  },

  updated() {
    this.setPromoStatus();
  },

  computed: {
    promoPercent() {
      return this.calculatePromo(this.originalPrice, this.specialPrice).toFixed(1);
    },
  },

  methods: {
    calculatePromo: function(originalPrice, currentPrice) {
      const increase = originalPrice - currentPrice;
      return (increase / originalPrice) * 100;
    },
    setPromoStatus() {
      typeof this.specialPrice !== "undefined" &&
      parseFloat(this.originalPrice).toFixed(2) !== parseFloat(this.specialPrice).toFixed(2)
        ? (this.hasPromo = true)
        : (this.hasPromo = false);
    },
  },
};
